export default __webpack_public_path__ + "landlord.en-us.1762504472222.json";